import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { openModal } from '@Header/Modals/ducks/actions';
import { selectPartner } from '@Header/ducks/selectors';
import { checkIfMobile } from '../../ducks/reducers';
import ApplicationSettings from '../../../services/ApplicationSettings';
import { Button, Copyright, Image, Message, PromotionInner, PromotionWrapper, } from './ContentStyles';

const RenderSection = (section, openPromotionModal, hasPartner, cdnUrl, isMobile) => {
  const shouldHideFromPartner = section.hideOnPartner && hasPartner;
  const shouldHideFromNonPartner = section.showOnPartnerOnly && !hasPartner;
  const shouldHideSection = shouldHideFromNonPartner || shouldHideFromPartner;
  if (shouldHideSection) {
    return null;
  }

  const isMobileSectionOnDesktop = !isMobile && section.isMobile;
  const isDesktopSectionOnMobile = isMobile && !section.isMobile;
  const shouldHideSectionForScreenSize = section.isMobile !== undefined
    && (isMobileSectionOnDesktop || isDesktopSectionOnMobile);
  if (shouldHideSectionForScreenSize) {
    return null;
  }

  const linkAttributes = {};
  if (section.link) {
    linkAttributes.target = '_self';
  }

  switch (section.type) {
    case 'image':
      return (
        <Image
          css={section.css}
          src={`${cdnUrl}/${section.imageUrl}`}
          alt={section.alt}
        />
      );
    case 'imageWithMap':
      return (
        <Fragment>
          <Image
            css={section.css}
            src={`${cdnUrl}/${section.imageUrl}`}
            alt={section.alt}
            useMap={`#${section.mapName}`}
          />
          <map name={section.mapName} id={section.mapName}>
            <area
              shape="rect"
              coords={section.clickCoords}
              href={(section.modalName ? '#' : section.link)}
              alt={(section.modalName ? '#' : section.link)}
              onClick={() => section.modalName && openPromotionModal(section.modalName)}
              {...linkAttributes}
            />
          </map>
        </Fragment>
      );
    case 'message':
      return (
        <Message css={section.css}>{section.message}</Message>
      );
    case 'button':
      return (
        <Button
          css={section.css}
          href={(section.modalName ? null : section.link)}
          onClick={() => section.modalName && openPromotionModal(section.modalName)}
          {...linkAttributes}
        >
          {section.message}
        </Button>
      );
    case 'copyright':
      return (
        <Copyright css={section.css}>{section.message}</Copyright>
      );
    default:
      return null;
  }
};

const Promotion = ({ content, openPromotionModal, hasPartner, isMobile }) => {
  const cdnUrl = ApplicationSettings.getApplicationSetting('cdnUrl');

  return !content?.sections?.length ? null : (
    <PromotionWrapper
      css={content.css}
      backgroundImage={content.backgroundImage && `${cdnUrl}/${content.backgroundImage}`}
      mobileBackgroundImage={content.mobileBackgroundImage && `${cdnUrl}/${content.mobileBackgroundImage}`}
    >
      <PromotionInner>
        {content.sections.map((section, index) => (
          // eslint-disable-next-line
          <Fragment key={`${section.type}-${index}`}>
            {RenderSection(section, openPromotionModal, hasPartner, cdnUrl, isMobile)}
          </Fragment>
        ))}
      </PromotionInner>
    </PromotionWrapper>
  );
};

Promotion.propTypes = {
  content: PropTypes.shape({
    sections: PropTypes.arrayOf(PropTypes.shape({
      type: PropTypes.string
    }))
  }),
  openPromotionModal: PropTypes.func.isRequired,
  hasPartner: PropTypes.bool,
  isMobile: PropTypes.bool.isRequired,
};

Promotion.defaultProps = {
  hasPartner: false,
  content: {}
};

const MapStateToProps = state => ({
  hasPartner: selectPartner(state).partnerId !== 1,
  isMobile: checkIfMobile(state),
});

const MapDispatchToProps = dispatch => ({
  openPromotionModal: modalName => dispatch(openModal(modalName)),
});

export default connect(MapStateToProps, MapDispatchToProps)(Promotion);
